var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-sub-headline"},[(_vm.text != null)?_c('h3',{staticClass:"sidebar-sub-headline__title"},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }